import * as types from './action-types';

export function getLogsKeyCreationSuccess(logs, totalPages, totalElements) {
  return {
    type: types.GET_LOGS_KEY_CREATION_SUCCESS,
    logs, totalPages, totalElements,
  };
}

export function getLogsKeyCreationError(error) {
  return {
    type: types.GET_LOGS_KEY_CREATION_ERROR,
    error,
  };
}
